import DatePickerCode from "!!raw-loader!./date/DatePicker";
import DateTimePickerCode from "!!raw-loader!./date/DateTimePicker";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import DatePicker from "./date/DatePicker";
import DateTimePicker from "./date/DateTimePicker";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("DatePicker", DatePickerCode, DatePicker),
		paneComponent("DateTimePicker", DateTimePickerCode, DateTimePicker),
	];

	return (
		<Pane
			components={components}
			imports={"import {DatePicker} from \"designSystem/index\";"}
			muiApi="pickers"
			muiComponent="pickers"
			{...props}
		/>
	);
};